var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgColorBucket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 23,
  viewBox: "0 0 25 23"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-948 -840)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ececec",
  fillRule: "nonzero",
  stroke: "#979797",
  d: "M-30.5-36.5h1571v1516h-1571z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M225 198h1198v1086H225z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  x: 943.5,
  y: 834.5,
  fill: "#e6e6e6",
  fillRule: "nonzero",
  stroke: "#e4e4e4",
  rx: 8
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M967.86 851.087c.972.607 1.73.912 2.265.912a.87.87 0 0 0 .641-.234c.465-.465.237-1.442-.678-2.906a26.2 26.2 0 0 0-3.594-4.357c-2.319-2.318-6.167-5.368-7.263-4.272-1.098 1.097 1.953 4.944 4.272 7.263a26.2 26.2 0 0 0 4.356 3.594"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M966.856 851.088a26.2 26.2 0 0 1-4.321-3.581 28 28 0 0 1-3.385-4.075q-.957-1.46-1.117-2.432l-1.314 1.664a7.6 7.6 0 0 0-1.404-.776c-2.96-1.253-6.123-.48-7.053 1.729-.673 1.596-.024 3.57 1.656 5.025.413.36.866.673 1.351.929l-.53.673a2.97 2.97 0 0 0 .226 3.928l4.935 4.96a2.93 2.93 0 0 0 3.908.227l9.192-7.324a6.3 6.3 0 0 1-2.144-.947m-7.282-2.582a1.61 1.61 0 0 1-2.109.862c-.058-.026-.111-.062-.167-.091-1.696 1.058-3.945.707-5.657-.177l-.003.003a6.7 6.7 0 0 1-1.337-.905c-1.483-1.285-2.071-2.993-1.5-4.352.804-1.911 3.624-2.543 6.286-1.417.445.188.87.421 1.266.697l-4.34 5.504c1.31.687 3.35 1.057 4.82.241a1.5 1.5 0 0 1-.23-.385 1.6 1.6 0 0 1 .005-1.238 1.606 1.606 0 0 1 2.767-.347c.347.46.423 1.073.2 1.605"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M958.389 847.079a.997.997 0 0 0-1.31.533.99.99 0 0 0 .16 1.033c.26-.217.463-.491.596-.801a.285.285 0 1 1 .526.222 2.7 2.7 0 0 1-.621.898 1 1 0 0 0 .649-1.886"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#05cd78",
  d: "M970.223 855.097a.306.306 0 0 0-.446 0c-.284.325-2.777 3.222-2.777 4.824 0 1.7 1.343 3.079 3 3.079s3-1.378 3-3.079c0-1.602-2.493-4.499-2.777-4.824m-.223 6.671c-.994 0-1.799-.827-1.8-1.847 0-.17.134-.308.3-.308s.3.138.3.308c0 .68.538 1.231 1.2 1.232.166 0 .3.138.3.308s-.134.307-.3.307"
})))));
export default SvgColorBucket;